import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
  pdfUrl: SafeResourceUrl;
  
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
   this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      '../../../assets/images/commission-disclosure.pdf'
    );
  }

}
